/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Requested_End_DateInputs */

const en_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Requested end date`)
};

const de_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewünschtes Beendigungsdatum`)
};

const fr_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de fin demandée`)
};

const es_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de finalización solicitada`)
};

const it_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di fine richiesta`)
};

const nl_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gevraagde einddatum`)
};

const pl_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żądana data zakończenia`)
};

const fi_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pyydetty päättymispäivä`)
};

const da_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ønsket slutdato`)
};

const sv_consumer_declaration_requested_end_date = /** @type {(inputs: Consumer_Declaration_Requested_End_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begärt slutdatum`)
};

/**
* | output |
* | --- |
* | "Requested end date" |
*
* @param {Consumer_Declaration_Requested_End_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_requested_end_date = /** @type {((inputs?: Consumer_Declaration_Requested_End_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Requested_End_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_requested_end_date(inputs)
	if (locale === "fr") return fr_consumer_declaration_requested_end_date(inputs)
	if (locale === "es") return es_consumer_declaration_requested_end_date(inputs)
	if (locale === "it") return it_consumer_declaration_requested_end_date(inputs)
	if (locale === "nl") return nl_consumer_declaration_requested_end_date(inputs)
	if (locale === "pl") return pl_consumer_declaration_requested_end_date(inputs)
	if (locale === "fi") return fi_consumer_declaration_requested_end_date(inputs)
	if (locale === "da") return da_consumer_declaration_requested_end_date(inputs)
	if (locale === "sv") return sv_consumer_declaration_requested_end_date(inputs)
	return en_consumer_declaration_requested_end_date(inputs)
});